import React, { useState } from "react";
import "./AutomationScriptWriter.css";

function AutomationScriptWriter() {
  const [feature, setFeature] = useState("");
  const [output, setOutput] = useState("");
  const [loading, setLoading] = useState(false);

  const generateScript = async () => {
    if (!feature.trim()) {
      alert("Please describe the automation scenario.");
      return;
    }

    setLoading(true);
    setOutput("");

    try {
      const response = await fetch(
        "https://qa-ai-platform-backend.onrender.com/api/automation-script",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ feature }),
        }
      );

      const data = await response.json();
      setOutput(data.script || "No script generated.");
    } catch (err) {
      console.error(err);
      setOutput("Failed to generate automation script.");
    }

    setLoading(false);
  };

  return (
    <div className="asw-container">
      <h1 className="asw-title">💻 Automation Script Writer</h1>

<p className="asw-subtitle">
  Generates production-ready <strong>MSTest + Selenium (POM)</strong> automation
  scripts based on real QA scenarios.
</p>

<textarea
  className="asw-input"
  placeholder="Example: Login test for valid user"
  value={feature}
  onChange={(e) => setFeature(e.target.value)}
/>


      <button className="asw-btn" onClick={generateScript} disabled={loading}>
        {loading ? "Generating..." : "Generate Automation Script"}
      </button>

      {output && (
  <div className="asw-output">
    <div className="asw-output-header">
      <h3>Generated Automation Code</h3>
      <button
        className="copy-btn"
        onClick={() => navigator.clipboard.writeText(output)}
      >
        Copy Code
      </button>
    </div>
    <pre><code>{output}</code></pre>
  </div>
)}
    </div>
  );
}

export default AutomationScriptWriter;
